// extracted by mini-css-extract-plugin
export default {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__Gg+3o","logo_normal":"WelcomeMessage_logo_normal__A9to9"};